<app-outline-button [text]="'Cancel'" (eventTriggered)="triggerEvent()"></app-outline-button>
